import { createContext, useContext } from 'react'

const SvdContext = createContext<boolean>(false)

// eslint-disable-next-line i18next/no-literal-string
const SVD_CONTEXT_DISPLAY_NAME = 'Svd Context'
SvdContext.displayName = SVD_CONTEXT_DISPLAY_NAME

/**
 * Single sitewide "is SVD active for this user?" read — no per-page/per-surface gate, the entire
 * app is either SVD or not. Seeded by `SvdContextProvider` (`_app.page.tsx`) from
 * `pageProps.isSvdEnabled`, the same override-aware value `getServerSideBaseProps` computes
 * (respects the `ramp_svd-rollout-web` query-param test override, unlike a direct client Statsig
 * experiment read). Prefer the `useIsSvdEnabled` wrapper
 * (`@src/quince-site-common/src/hooks/use-is-svd-enabled`).
 */
export const useSvdContext = (): boolean => useContext(SvdContext)

export default SvdContext
